import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmnDebounceDirective } from './cmn-debounce/cmn-debounce.directive';
import { CmnEmailDirective } from './cmn-email/cmn-email.directive';
import { CmnMaxDirective } from './cmn-max/cmn-max.directive';
import { CmnMinDirective } from './cmn-min/cmn-min.directive';
import { NumericOnlyDirective } from './numeric-only/numeric-only.directive';
import {AutofocusDirective} from './autofocus/autofocus.directive';
import {CmnDeviceNameDirective} from './cmn-deviceName/cmn-deviceName.directive';
import {CmnPhoneDirective} from './cmn-phone/cmn-phone.directive';
import {CmnUrlDirective} from './cmn-url/cmn-url.directive';
import {CmnReplaceTagDirective} from './cmn-replace-tag/cmn-replace-tag.directive';

const directives = [
    AutofocusDirective,
    CmnDebounceDirective,
    CmnDeviceNameDirective,
    CmnEmailDirective,
    CmnMaxDirective,
    CmnMinDirective,
    CmnPhoneDirective,
    CmnUrlDirective,
    NumericOnlyDirective,
    CmnReplaceTagDirective,
];

@NgModule({
  declarations: [...directives],
  imports:      [
    CommonModule,
    PortalModule
  ],
  exports:      [...directives]
})
export class DirectivesModule {
}
